import { ToolSet } from "@app/tool/model/toolSet.model";
import { Tool } from "@app/tool/model/tool.model";

export class ToolBulkReset {
  public tools: Array<ToolSet | Tool>;
  public scanned: { [toolId: number]: boolean };

  constructor(tbr: any = {}) {
    this.tools = tbr.tools || [];
    this.scanned = tbr.scanned || {};
  }
}